(() => {
  const tracks = '.rv-gallery-track';
  const cache = new Map();
  const desktop = () => matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
  const count = track => track.children.length;
  document.addEventListener('pointerover', event => {
    const track = event.target.closest(tracks);
    if (track && desktop() && event.pointerType === 'mouse' && !track.contains(event.relatedTarget) && count(track) > 1) track.classList.add('rv-preview-hover');
  });
  document.addEventListener('pointerout', event => {
    const track = event.target.closest(tracks);
    if (track && desktop() && event.pointerType === 'mouse' && !track.contains(event.relatedTarget)) track.classList.remove('rv-preview-hover');
  });
  document.addEventListener('keydown', event => {
    const track = event.target.closest('.rv-card-preview')?.querySelector('.rv-gallery-track');
    if (track && desktop() && (event.key==='ArrowRight' || event.key==='ArrowLeft')) { event.preventDefault(); track.classList.toggle('rv-preview-hover',event.key==='ArrowRight' && count(track)>1); }
  });
  async function enhance(link) {
    const swipeRecommendation = !!link.closest('.rv-recommendations-slot,.rv-related,.rv-smart-recs');
    if (!desktop() && !swipeRecommendation) return;
    if (link.dataset.rvPreview || link.closest('.rv-card-gallery__track,.card-gallery,.rv-card-preview') || !link.querySelector('img')) return;
    link.dataset.rvPreview='loading';
    const handle=new URL(link.href).pathname.split('/products/')[1]?.split('/')[0];
    if (!handle) return;
    if (!cache.has(handle)) cache.set(handle,fetch(((window.Shopify&&Shopify.routes.root)||'/')+'products/'+encodeURIComponent(handle)+'.js').then(r=>r.ok?r.json():null).catch(()=>null));
    const product=await cache.get(handle);
    if (!link.isConnected || !product || product.images.length<2) return;
    const first=link.querySelector('img');
    const relatedImage=link.querySelector('.rv-related__image');
    const wrapper=relatedImage || document.createElement('div'); wrapper.classList.add('rv-card-preview');
    if (!relatedImage) { link.before(wrapper); wrapper.append(link); }
    const track=document.createElement('div'); track.className='rv-gallery-track';
    first.draggable=false; track.append(first);
    product.images.slice(1).forEach(src=>{
      const img=document.createElement('img'); const url=new URL(src,location.origin); url.searchParams.set('width','500');
      img.src=url.href; img.alt=product.title; img.width=500; img.height=500; img.loading='lazy'; img.draggable=false; track.append(img);
    });
    (relatedImage || link).append(track); link.dataset.rvPreview='ready';
    // Native horizontal scrolling on touch; a swipe must not open the product.
    if (swipeRecommendation) {
      track.setAttribute('tabindex', '0');
      track.setAttribute('aria-label', 'Product photos; swipe left or right');
      let startX = 0, startY = 0, dragged = false, resetTimer;
      track.addEventListener('touchstart', event => {
        clearTimeout(resetTimer);
        dragged = false;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, {passive:true});
      track.addEventListener('touchmove', event => {
        const dx = Math.abs(event.touches[0].clientX - startX);
        const dy = Math.abs(event.touches[0].clientY - startY);
        if (dx > 10 && dx > dy) dragged = true;
      }, {passive:true});
      track.addEventListener('touchend', () => { resetTimer = setTimeout(() => { dragged = false; }, 400); }, {passive:true});
      link.addEventListener('click', event => {
        if (!dragged) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        dragged = false;
      }, true);
      track.addEventListener('keydown', event => {
        if (desktop() || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        const next = Math.round(track.scrollLeft / track.clientWidth) + (event.key === 'ArrowRight' ? 1 : -1);
        track.scrollTo({left: Math.max(0, Math.min(track.children.length - 1, next)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    }
  }
  let pending=false;
  function scan(){document.querySelectorAll('a.rv-rec-image,a.rv-smart-img,a.rv-related__link').forEach(enhance);}
  new MutationObserver(()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;scan();});}).observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('resize',scan);
  scan();
})();

